export default "__VITE_ASSET__BltsYj2N__"